import { useAuth } from '@context/auth/base';
import type { GetDraftQuery } from '@graphql/reactQuery';
import { GetDraftDocument, useQuery } from '@graphql/reactQuery';
import { NEW_DRAFT_ID } from './shared';

export type DraftDataRewardInfo = NonNullable<
  NonNullable<GetDraftQuery['draft']['info']>['rewardsInfo']
>;

export function useDraftData({
  draftId,
  disabled = false,
}: {
  draftId: string | undefined;
  disabled?: boolean;
}) {
  const { isAuthenticatedWithAPI } = useAuth();
  const { data, isInitialLoading: loading } = useQuery(GetDraftDocument, {
    variables: !!draftId &&
      draftId !== NEW_DRAFT_ID && {
        draftId,
      },
    enabled: isAuthenticatedWithAPI && !disabled,
    cacheTime: 0,
    staleTime: 0,
  });

  return {
    draft: data?.data.draft,
    loading,
  };
}
